@if (property && property.user) {
  <div class="listing-frame" [class.listing-sponsored]="isSponsered()">
    <span
      class="listing-legend"
      [class.listing-legend-hidden]="!isSponsered()"
      [attr.aria-hidden]="!isSponsered()"
    >
      {{ 'SPONSORED' | translate }}
    </span>
    <div
      class="card listing-card h-100 clickable-card cursor-poiner"
      role="link"
      tabindex="0"
      (keydown.enter)="$event.target === $event.currentTarget && goToDetails(property.id)"
      (click)="goToDetails(property.id)"
    >
      <!-- Carousel -->
      <property-images-carousel-component
        #images
        [displayLikeButton]="false"
        [listingCard]="true"
        [property]="property"
        [carouselId]="listId()"
      ></property-images-carousel-component>
      <!-- Card Body -->
      <div class="card-body">
        <div class="listing-title-row">
          <h5 class="card-title">
            {{ property.title }}
            @if (property.status === statuses.Pending) {
              <span class="badge text-bg-warning">{{ property.status | translate }}</span>
            }
          </h5>
          @if (!property.isExpired && property.status !== statuses.Sold) {
            <button
              type="button"
              class="listing-favorite"
              [attr.aria-pressed]="images.isLiked()"
              [attr.aria-label]="
                (images.isLiked() ? 'REMOVE_FROM_FAVORITES' : 'ADD_TO_FAVORITES') | translate
              "
              (click)="images.toggleLike($event)"
              (keydown)="$event.stopPropagation()"
            >
              <i
                [class]="images.isLiked() ? 'bi bi-heart-fill' : 'bi bi-heart'"
                aria-hidden="true"
              ></i>
            </button>
          }
        </div>
        <div class="row">
          <div class="col-6">
            <p class="card-text">
              <i class="bi bi-house-door-fill p-1"></i>
              {{ property.propertyType | translate }}
            </p>
          </div>

          <div class="col-6">
            <p class="card-text">
              <i class="bi bi-bounding-box-circles p-1"></i>
              {{ property.floorArea }}
              @if (property.landArea) {
                <span></span>/{{ property.landArea }}
              }
              {{ 'M2' | translate }}
            </p>
          </div>
          <div class="col-6">
            <p class="card-text">
              @if (property.city) {
                <i class="bi bi-geo-alt-fill p-1"></i>{{ property.city | syrianCity }}
              }
            </p>
          </div>
          <div class="col-6">
            <p class="card-text">
              @if (property.rooms) {
                <i class="bi bi-door-closed-fill p-1"></i>{{ property.rooms }}
              }
              @if (property.rooms && property.bathrooms) {
                /
              }
              @if (property.bathrooms) {
                <span class="p-2"><img src="icons/shower.png" width="18" height="20" /></span>
                <span>{{ property.bathrooms }}</span>
              }
            </p>
          </div>
        </div>
      </div>
      <div class="card-footer text-body-secondary py-0">
        <div class="row">
          <div class="col-7">
            <p class="card-text small">
              <span class="px-1"
                ><img
                  loading="lazy"
                  [src]="'plans/' + property.user.plan + '.png'"
                  width="14"
                  height="15"
              /></span>
              <span>{{ property.user.name }}</span>
            </p>
          </div>
          <div class="col-5">
            <p class="card-text small">
              <i class="bi bi-clock-fill px-1"></i>{{ property.createdAt | date: 'dd.MM.yyyy' }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
}
